import { useHistoryCustomBack } from 'weblite-router'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Components
import { BottomDrawer } from '$common/bottom-drawer'
import { CulturalContentsSelectMenu } from '$comp/chat-list-tool-box/components/cultural-contents-select-menu'
import { showChatListToolboxModal } from '$comp/modals/chat-list-toolbox/index'

export interface ChatListToolboxCulturalContentsModalProps {
  isOpen?: boolean
  onBack?: () => void
}
export function ChatListToolboxCulturalContentsModal({
  isOpen,
  onBack,
}: ChatListToolboxCulturalContentsModalProps) {
  const handleBack = async () => {
    if (onBack) onBack()
    else {
      await closeCurrentModal()
      showChatListToolboxModal()
    }
  }

  useHistoryCustomBack(() => {
    handleBack()
  }, [])

  return (
    <BottomDrawer
      isOpen={Boolean(isOpen)}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
    >
      <CulturalContentsSelectMenu onBack={handleBack} />
    </BottomDrawer>
  )
}
